import script from "./TemplateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateForm.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateForm.vue?vue&type=style&index=0&id=18370e00&lang=scss"

const __exports__ = script;

export default __exports__